import theme from '../styles/theme';

export default {
  computed: {
    ...theme,
  },
};
